import * as types from './actionTypes';

const initialState = {
  keys_responsibilities: null,
  loading: false,
  error: null,
  success: false,
};

const keysResponsibilitiesReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_KEYS_RESPONSIBILITIES:
    case types.SAVE_KEYS_RESPONSIBILITIES:
    case types.CHANGE_KEYS_RESPONSIBILITIES_STATUS:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };

    case types.FETCH_KEYS_RESPONSIBILITIES_SUCCESS:
      return {
        ...state,
        keys_responsibilities: action.payload?.data,
        loading: false,
        success: false,
      };

    case types.SAVE_KEYS_RESPONSIBILITIES_SUCCESS:
    case types.CHANGE_KEYS_RESPONSIBILITIES_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };

    case types.FETCH_KEYS_RESPONSIBILITIES_FAILURE:
    case types.SAVE_KEYS_RESPONSIBILITIES_FAILURE:
    case types.CHANGE_KEYS_RESPONSIBILITIES_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };

    default:
      return state;
  }
};

export default keysResponsibilitiesReducer;
